import  { useEffect, useState } from "react";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import { CircularProgress, Container, Typography, Box } from "@mui/material";
import config from "../../config.js";

ChartJS.register(Tooltip, Legend, CategoryScale, LinearScale, BarElement);

const SalesChart = () => {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const [error, setError] = useState(null);
  const { API_BASE_URL } = config;


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/v1/learningJson`
        );
        

        const rawData = response.data.data.Data;
       

        const months = [...new Set(rawData.map((item) => item["Month"]))];
        const parameters = [
          "Cost Ad",
          "successful calls",
          "Marketing Power",
          "Selling Power",
        ];

        const colorPalette = [
          "rgba(255, 99, 132, 0.6)",
          "rgba(54, 162, 235, 0.6)",
          "rgba(255, 206, 86, 0.6)",
          "rgba(75, 192, 192, 0.6)",
        ];

        const borderColorPalette = [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
        ];

        const datasets = parameters.map((parameter, index) => {
          const data = months.map((month) => {
            const monthData = rawData.filter((item) => item["Month"] === month);
            return monthData.reduce(
              (total, item) => total + item[parameter],
              0
            );
          });
          return {
            label: parameter,
            data: data,
            backgroundColor: colorPalette[index],
            borderColor: borderColorPalette[index],
            borderWidth: 1,
          };
        });


        setChartData({
          labels: months,
          datasets: datasets,
        });
      } catch (error) {
        setError(error);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!chartData.labels.length) {
    return (
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  } else {
    const options = {
      responsive: true,
      scales: {
        x: {
          stacked: true,
        },
        y: {
          stacked: true,
          beginAtZero: true,
        },
      },
      plugins: {
        legend: {
          display: true,
          labels: {
            color: "white", 
            font: {
              size: 14,
            },
          },
        },
      },
      elements: {
        bar: {
          maxBarThickness: 80, 
        },
      },
      animations: {
        radius: {
          duration: 400,
          easing: "linear",
          loop: (context) => context.active,
        },
      },
      hoverRadius: 12,
      hoverBackgroundColor: "yellow",
      interaction: {
        mode: "nearest",
        intersect: false,
        axis: "x",
      },
    };

    return (
      <div>
        <Box sx={{ backgroundColor: "#FF4D4D", padding: 2, borderRadius: 1 }}>
          <Typography variant="h5" sx={{ color: "#fff", textAlign: "center" }}>
            Total Sales by Month and Parameter
          </Typography>
        </Box>
        <Container>
          <div
            style={{
              padding: "20px",
              width: "100%",
              height: "80%",
            }}
          >
            <Bar data={chartData} options={options} />
          </div>
        </Container>
      </div>
    );
  }
};

export default SalesChart;
